

module.exports = __webpack_require__.stylable.create(
    "Tooltip1570944881",
    {"classes":{"root":"Tooltip1570944881__root","popoverContent":"Popover3641543974__popoverContent","popover":"Popover3641543974__popover","arrow":"Popover3641543974__arrow","withArrow":"Popover3641543974__withArrow"},"vars":{},"stVars":{"contentArrowSize":"8px"},"keyframes":{}},
    "",
    3,
    "Tooltip1570944881",
    null
);
